import React, { useState } from 'react'
import { fetchData } from '../../service/dataServices';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
const { Option } = Select;

export default function UserDropdown({ label, fieldName, hasWritePermission, disabled = false }) {

  const [userList, setUserList] = useState(null);
  fetchData('/api/users/user-refs', setUserList);
  const { t } = useTranslation();

  return (
    <Form.Item label={label} name={fieldName}>
      <Select
        showSearch
        filterOption
        optionFilterProp="children"
        placeholder={t("common.select_user")}
        disabled={!hasWritePermission || disabled}
        allowClear
      >
        {
          userList?.map(option => (
            <Option value={option.id} key={option.id}>{option.name}</Option>
          ))
        }
      </Select>
    </Form.Item>
  )
}
